<template>
  <div class="judge-panel">
    <div class="top-left">Судья: {{ judgeName }}</div>
    <button class="top-right" @click="$emit('back')">Назад</button>

    <div v-if="!currentCategory" class="waiting">
      <p>Ожидание начала номинации...</p>
      <p>Как только администратор запустит номер — вы увидите его здесь</p>
    </div>

    <div v-else class="center-content">
      <div class="entry-title">{{ currentCategory }}</div>

      <div class="score-grid">
        <button
          v-for="score in [5, 6, 7, 8, 9, 10]"
          :key="score"
          @click="selectScore(score)"
          :class="{ selected: pendingScore === score }"
          :disabled="isSubmitting || scoreSubmitted"
          class="score-btn"
        >
          {{ score }}
        </button>
      </div>

      <button
        @click="submitScore"
        :disabled="!pendingScore || isSubmitting || scoreSubmitted"
        class="submit-btn"
        :class="{ success: scoreSubmitted }"
      >
        {{ submitText }}
      </button>

      <p v-if="scoreSubmitted" class="sent-info">
        Оценка {{ lastSentScore }} отправлена! Ждём следующий номер...
      </p>
    </div>
    <!-- Тост -->
    <div v-if="toastMessage" class="toast" :class="toastType">
      {{ toastMessage }}
    </div>
  </div>
</template>

<script>
export default {
  name: "JudgePanel",
  props: {
    eventName: { type: String, required: true },
    judgeName: { type: String, required: true },
  },
  data() {
    return {
      ws: null,
      connected: false,
      currentCategory: null,
      currentData: {},
      pendingScore: null,
      scoreSubmitted: false,
      lastSentScore: null,
      isActive: true, // ← вот он
      isSubmitting: false,
      toastMessage: "",
      toastType: "success", // success или error
    };
  },
  computed: {
    submitText() {
      if (!this.connected) return "Нет соединения...";
      if (this.isSubmitting) return "Отправляем...";
      if (this.scoreSubmitted) return "Оценка отправлена";
      return this.pendingScore
        ? `Отправить ${this.pendingScore}`
        : "Выберите оценку";
    },
  },
  mounted() {
    console.log(
      `[JudgePanel] ${this.judgeName} – компонент смонтирован, подключаемся...`
    );
    this.connectWebSocket();
  },
  beforeDestroy() {
    console.log(`[JudgePanel] ${this.judgeName} – компонент уничтожается`);
    this.isActive = false; // ← ВОТ ЭТО ОБЯЗАТЕЛЬНО!
    if (this.ws) {
      this.ws.onclose = null;
      this.ws.onerror = null;
      this.ws.close();
    }
  },
  methods: {
    showToast(message, type = "success") {
      this.toastMessage = message;
      this.toastType = type;
      setTimeout(() => {
        this.toastMessage = "";
      }, 3000); // исчезает через 3 секунды
    },
    connectWebSocket() {
      const protocol = location.protocol === "https:" ? "wss:" : "ws:";
      const wsUrl = `${protocol}//${location.host}/ws-dance`;

      console.log(
        `[JudgePanel] ${this.judgeName} пытается подключиться к ${wsUrl}`
      );
      this.ws = new WebSocket(wsUrl);
      this.connected = false;

      this.ws.onopen = () => {
        this.connected = true;
        console.log(
          `[JudgePanel] ${this.judgeName} – WebSocket успешно подключён`
        );
        this.ws.send(
          JSON.stringify({
            action: "subscribe",
            event: this.eventName,
          })
        );
      };

      this.ws.onmessage = (e) => {
        const msg = JSON.parse(e.data);
        console.log(`[JudgePanel] ${this.judgeName} получил сообщение:`, msg);

        if (msg.type === "init" && msg.data) {
          this.currentData = msg.data;
          this.updateFromData();
        }
        if (msg.type === "patch" && msg.changes) {
          this.applyPatch(msg.changes);
        }
      };

      this.ws.onclose = () => {
        this.connected = false;
        console.log(`[JudgePanel] ${this.judgeName} – WebSocket закрыт`);

        // Сбрасываем состояние только если компонент ещё живой
        if (this.isActive) {
          console.log(
            `[JudgePanel] ${this.judgeName} – переподключаемся через 2с`
          );
          this.currentCategory = null;
          this.scoreSubmitted = false;
          this.pendingScore = null;
          this.lastSentScore = null;

          setTimeout(() => this.connectWebSocket(), 2000);
        } else {
          console.log(
            `[JudgePanel] ${this.judgeName} – компонент уничтожен, переподключение отменено`
          );
        }
      };

      this.ws.onerror = (err) => {
        console.warn(`[JudgePanel] ${this.judgeName} – ошибка WebSocket`, err);
        this.connected = false;
      };
    },

    updateFromData() {
      const categories = Object.keys(this.currentData);
      if (categories.length === 0) {
        this.currentCategory = null;
        return;
      }
      const newCategory = categories[0];
      if (newCategory !== this.currentCategory) {
        console.log(
          `[JudgePanel] ${this.judgeName} – новая активная номинация: ${newCategory}`
        );
        this.currentCategory = newCategory;
        this.scoreSubmitted = false;
        this.pendingScore = null;
        this.lastSentScore = null;
      }
    },

    applyPatch(changes) {
      for (const [category, judges] of Object.entries(changes)) {
        if (!this.currentData[category]) this.currentData[category] = {};
        Object.assign(this.currentData[category], judges);
      }
      this.updateFromData();
    },

    selectScore(score) {
      if (!this.connected || this.scoreSubmitted) return;
      this.pendingScore = score;
      console.log(`[JudgePanel] ${this.judgeName} выбрал оценку: ${score}`);
    },

    async submitScore() {
      if (!this.connected || !this.pendingScore || this.scoreSubmitted) return;

      this.isSubmitting = true;
      console.log(
        `[JudgePanel] ${this.judgeName} отправляет оценку ${this.pendingScore} за ${this.currentCategory}`
      );

      try {
        const res = await fetch(
          "https://letsdancescores.tech/danceapi/submit-score.php",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              event: this.eventName,
              category: this.currentCategory,
              judge: this.judgeName,
              score: this.pendingScore,
            }),
          }
        );

        const result = await res.json();
        if (result.success) {
          this.scoreSubmitted = true;
          this.lastSentScore = this.pendingScore;
          this.pendingScore = null;

          // Тостик вместо alert
          this.showToast(`Оценка ${this.lastSentScore} отправлена!`);

          console.log(
            `[JudgePanel] ${this.judgeName} – оценка успешно отправлена`
          );
        } else {
          this.showToast(
            "Ошибка отправки: " + (result.error || "неизвестно"),
            "error"
          );
        }
      } catch (err) {
        alert("Нет связи с сервером");
        console.error(`[JudgePanel] Ошибка сети при отправке`, err);
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<style scoped>
.judge-panel {
  width: 100vw;
  height: 100vh;
  background: radial-gradient(circle at center, rgba(0, 0, 80, 0.8), #000 40%);
  color: #fff;
  font-family: sans-serif;
  overflow: hidden;
  position: relative;
}

/* Имя судьи слева сверху */
.top-left {
  position: absolute;
  top: 20px;
  left: 20px;
  font-size: 16px;
  opacity: 0.7;
}

/* Номинация справа сверху */
.top-right {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 18px;
  text-align: right;
  opacity: 0.8;
  padding: 8px 14px;
  font-size: 14px;
  background: rgba(120, 170, 255, 0.25);
  color: white;
  border: 1px solid rgba(150, 200, 255, 0.55);
  border-radius: 10px;
  backdrop-filter: blur(6px);
  cursor: pointer;
  transition: 0.25s;
}

/* Центральный блок */
.center-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  width: 100%;
}

.entry-title {
  font-size: 48px;
  margin-bottom: 40px;
}

/* Кнопки оценки */
.score-grid {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.score-btn {
  padding: 22px 32px;
  font-size: 30px;
  font-weight: 800;
  background: rgba(120, 170, 255, 0.22);
  color: white;
  border: 2px solid rgba(150, 200, 255, 0.55);
  border-radius: 18px;
  backdrop-filter: blur(10px);
  box-shadow: 0 0 12px rgba(0, 140, 255, 0.45),
    0 0 30px rgba(0, 120, 255, 0.25) inset;
  cursor: pointer;
  transition: 0.25s ease;
}
.score-btn:hover:not(:disabled) {
  background: rgba(0, 255, 98, 0.55);
  border-color: rgba(180, 220, 255, 0.9);
  box-shadow: 0 0 18px rgba(0, 160, 255, 0.7),
    0 0 40px rgba(0, 140, 255, 0.45) inset;
  transform: scale(1.1);
}
.score-btn.selected {
  background: rgba(0, 255, 98, 0.55);
  border-color: rgba(0, 180, 255, 1);
  box-shadow: 0 0 25px rgba(0, 160, 255, 0.85),
    0 0 45px rgba(0, 140, 255, 0.5) inset;
  transform: scale(1.15);
}
.score-btn:disabled {
  background: rgba(60, 60, 80, 0.3);
  border-color: rgba(80, 80, 120, 0.4);
  cursor: not-allowed;
}

/* Кнопка отправки */
.submit-btn {
  margin-top: 30px;
  padding: 18px 42px;
  font-size: 24px;
  font-weight: 700;
  background: rgba(0, 120, 255, 0.4);
  color: white;
  border: 2px solid rgba(0, 150, 255, 0.65);
  border-radius: 16px;
  cursor: pointer;
  backdrop-filter: blur(10px);
  transition: 0.25s ease;
  box-shadow: 0 0 15px rgba(0, 130, 255, 0.55),
    0 0 35px rgba(0, 110, 255, 0.3) inset;
}
.submit-btn:hover:not(:disabled) {
  background: rgba(0, 255, 98, 0.55);
  border-color: rgba(0, 180, 255, 1);
  box-shadow: 0 0 22px rgba(0, 160, 255, 0.9),
    0 0 45px rgba(0, 140, 255, 0.4) inset;
  transform: scale(1.08);
}
.submit-btn:disabled {
  background: rgba(70, 70, 90, 0.3);
  border-color: rgba(100, 100, 130, 0.3);
  cursor: not-allowed;
}

.sent-info {
  margin-top: 20px;
  color: #4caf50;
  font-size: 20px;
}

/* Кнопка назад */

.back-btn:hover {
  background: rgba(0, 255, 98, 0.55);
  transform: scale(1.07);
}
.toast {
  position: fixed;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  padding: 14px 28px;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 600;
  z-index: 1000;
  animation: toastAppear 0.4s ease;
  box-shadow: 0 8px 25px rgba(0,0,0,0.4);
}

.toast.success {
  background: rgba(0, 200, 100, 0.95);
  border: 2px solid rgba(0, 255, 120, 0.8);
}

.toast.error {
  background: rgba(220, 50, 50, 0.95);
  border: 2px solid rgba(255, 80, 80, 0.8);
}

@keyframes toastAppear {
  from { opacity: 0; transform: translateX(-50%) translateY(20px); }
  to   { opacity: 1; transform: translateX(-50%) translateY(0); }
}
</style>
